import {
  ContentBlocks,
  contentBlocksQuery,
} from '@/components/contentBlocks/ContentBlocks'
import { Hero } from '@/components/Hero'
import { statamicGraphqlEndpoint } from '@/globals/globals'
import {
  AspectRatio,
  Box,
  Container,
  GridItem,
  Heading,
  Image,
  SimpleGrid,
} from '@chakra-ui/react'
import request, { gql } from 'graphql-request'
import { GetStaticProps } from 'next'
import ReactMarkdown from 'react-markdown'

export const getStaticProps: GetStaticProps = async () => {
  const data = await request(
    statamicGraphqlEndpoint,
    gql`
      query MyQuery {
        entry(collection: "pages", slug: "about") {
          title
          id
          ... on Entry_Pages_PageAbout {
            id
            heading
            team_heading
            pre_heading
            intro
            ${contentBlocksQuery}
          }
        }
        entries(collection: "team") {
          data {
            ... on Entry_Team_TeamMember {
              id
              bio
              title
              position
              headshot {
                url
              }
            }
          }
        }
      }

    `
  )

  return {
    props: {
      data: data.entry,
      team: data.entries.data,
    },
    revalidate: 60,
  }
}

export const AboutPage = ({ data, team }: any) => {
  return (
    <>
      <Hero heading={data.title} subheading={data.intro} />
      <Container maxWidth='6xl' textAlign='center' py={20}>
        <Heading as='h2' fontSize='lg' mb={8}>
          {data.team_heading}
        </Heading>
        <SimpleGrid columns={{ base: 2, md: 3, lg: 5 }} spacing={12}>
          {team.map((member: any, i: number) => (
            <GridItem key={i}>
              <AspectRatio ratio={234 / 352} mb={8}>
                <Image src={member.headshot.url} alt={member.title} />
              </AspectRatio>
              <Heading as='h3' fontSize='md' mt={4}>
                {member.title}
              </Heading>
              <Heading as='h4' fontSize='sm' mt={2}>
                {member.position}
              </Heading>
              <Box mt={4}>
                <ReactMarkdown>{member.bio}</ReactMarkdown>
              </Box>
            </GridItem>
          ))}
        </SimpleGrid>
      </Container>
      <Box pb={20}>
        <ContentBlocks {...data} />
      </Box>
    </>
  )
}

export default AboutPage
